import {z} from '@hono/zod-openapi';

import {VoiceUsageNormalizedTokenCountsSchema} from './VoiceUsageNormalizedTokenCountsSchema';

export const VoiceUsageObservationSchema = z
  .object({
    schemaVersion: z.literal('1.0.0'),
    voiceConversationId: z.string().min(1).max(128).regex(/\S/),
    providerCallId: z.string().min(1).max(128).regex(/\S/),
    realtimeSessionId: z.string().min(1).max(128).regex(/\S/).nullable(),
    responseId: z.string().min(1).max(128).regex(/\S/),
    providerEventId: z.string().min(1).max(128).regex(/\S/),
    observedAt: z.string().datetime({offset: true}),
    model: z.string().min(1).max(128).regex(/\S/),
    usage: VoiceUsageNormalizedTokenCountsSchema,
  })
  .strict()
  .openapi('VoiceUsageObservationSchema');

export type VoiceUsageObservation = z.infer<typeof VoiceUsageObservationSchema>;
